export default {
    type_expenses: [],
    cost_centers: [],
    cost_centers_employees: [],
    paying_sources: [],
    providers: [],
}
